import { persistent } from '../services/LocalStorage'
import * as Constants from '../services/Constants'
import CrossPlatformDialog from '@/dialogs/components/CrossPlatformDialog'
import { DialogBody } from '@/components/Dialog'
import DialogActionButtonsSection from '@/dialogs/components/DialogActionButtonsSection'

function FirstTimeAppNoticePopup({ onClose }: { onClose: (ignoreAndContinue: boolean) => void }) {
    const close = () => {
        persistent.set(Constants.appstart_notifications_suppress_id, Constants.appstart_notification.id)
        onClose(true)
    }

    const html = Constants.appstart_notification.html

    if (!html) {
        return null
    }

    return (
        <CrossPlatformDialog forceBrowserModal classNameBrowser="md:w-[680px]" onDefaultClose={close}>
            <DialogBody>
                <div dangerouslySetInnerHTML={{ __html: html }} />
            </DialogBody>
            <DialogActionButtonsSection rightButtonText={'OK'} onRightButtonClicked={close} />
        </CrossPlatformDialog>
    )
}

export default FirstTimeAppNoticePopup
